import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { ReactNode } from "react";

interface DeleteJobConfirmDialogProps {
  open: boolean;
  title: string;
  message: ReactNode;
  deleteData: boolean;
  onDeleteDataChange: (value: boolean) => void;
  onCancel: () => void;
  onConfirm: () => void;
  confirmDisabled?: boolean;
  busy?: boolean;
  paperSx?: object;
}

/**
 * Shared confirmation dialog for every job-delete action in Bots Management.
 * The checkbox wipes the job's whole S3 data folder (logs, matches files,
 * error screenshots, downloaded data) together with the DB rows.
 */
export default function DeleteJobConfirmDialog({
  open,
  title,
  message,
  deleteData,
  onDeleteDataChange,
  onCancel,
  onConfirm,
  confirmDisabled = false,
  busy = false,
  paperSx,
}: DeleteJobConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={() => !busy && onCancel()}
      maxWidth="xs"
      fullWidth
      PaperProps={paperSx ? { sx: paperSx } : undefined}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ mt: 0.5 }}>
        <Typography variant="body2">{message}</Typography>
        <FormControlLabel
          sx={{ mt: 1 }}
          control={
            <Checkbox
              checked={deleteData}
              onChange={(e) => onDeleteDataChange(e.target.checked)}
              size="small"
              disabled={busy}
            />
          }
          label="Also delete job's data from S3 (logs, matches, screenshots)"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={busy}>
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={confirmDisabled || busy}
          onClick={onConfirm}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
